import React from "react";
import styles from "../../styles/shap_of_you.module.scss";
import { ImageNotPermittedScreenProps } from "./types";

const ImageNotPermittedScreen: React.FC<ImageNotPermittedScreenProps> = ({
  navigateToStep,
  errorMessage,
  onRetry,
  capturedImage,
}) => {
  const handleReupload = () => {
    if (onRetry) {
      onRetry();
    } else {
      navigateToStep("uploadOrScan");
    }
  };

  return (
    <div className="d-none d-md-block w-100">
      <div
        className={styles.image_error_screen}
        style={capturedImage ? { backgroundImage: `url(${capturedImage})` } : undefined}
      >
        <div className={styles.error_content}>
          <div className={styles.error_box}>
            <svg
              className={styles.warning_icon}
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55296 18.6453 1.55199 18.9945C1.55101 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.901 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
                stroke="#C9302C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <h3 className={styles.error_title}>Image Upload Error</h3>
            <p className={styles.error_message}>
              {errorMessage ||
                "Please upload an image where the face is clearly visible and properly lit."}
            </p>
          </div>

          <button className={styles.reupload_btn} onClick={handleReupload}>
            Reupload Image
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 16L8.586 11.414C8.96106 11.0391 9.46967 10.8284 10 10.8284C10.5303 10.8284 11.0389 11.0391 11.414 11.414L16 16M14 14L15.586 12.414C15.9611 12.0391 16.4697 11.8284 17 11.8284C17.5303 11.8284 18.0389 12.0391 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageNotPermittedScreen;
